import { useInfiniteQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { unwrap, type ApiError } from "@/api/errors";
import { queryKeys } from "@/api/queryKeys";
import type { ActivityPage } from "@/api/types";

export type { ActivityPage } from "@/api/types";
export const ACTIVITY_PAGE_SIZE = 20;

export function useActivity(orgSlug: string, projectSlug: string) {
  return useInfiniteQuery<ActivityPage, ApiError, { pages: ActivityPage[] }, readonly unknown[], string | null>({
    queryKey: queryKeys.activity(orgSlug, projectSlug),
    initialPageParam: null,
    queryFn: async ({ pageParam }) =>
      unwrap(
        await api.GET("/orgs/{slug}/projects/{pslug}/activity", {
          params: {
            path: { slug: orgSlug, pslug: projectSlug },
            query: { limit: ACTIVITY_PAGE_SIZE, ...(pageParam ? { cursor: pageParam } : {}) },
          },
        }),
      ),
    getNextPageParam: (last) => last.next_cursor ?? undefined,
  });
}
